module.exports = __webpack_public_path__ + "static/img/hw-link.ba19201b.svg";